<!-- 展品列表 -->
<template>
  <div>
    <div class="van-hairline--bottom goods-view" v-for="(item, index) in dataList" :key="index">
      <van-image class="goods-icon" width="110px" height="110px" radius="10" fit="cover" :src="item.iconUrl.split(',')[0]" />
      <div class="goods-desc-view">
        <div class="van-multi-ellipsis--l2 goods-title">{{item.productName}}</div>
        <div class="goods-select" @click="select(item)">选择</div>
      </div>
    </div>
    <div class="nodata-view" v-if="dataList.length == 0">
      <nodata msg="未上传展品</br>请到“我的->公司管理->展品管理”中进行添加"></nodata>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import {mapState, mapGetters} from 'vuex'
import nodata from '@/components/noData.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    nodata
  },
  data () {
    // 这里存放数据
    return {
      dataList: []
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      activeElementUUID: state => state.editor.activeElementUUID
    }),
    ...mapGetters([
      'projectData',
      'getActiveElementUUID',
      'getTemplate'
    ]),
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getData() {
      var params = {
        exhibitorId: this.$store.state.user.exhibitorId
      }
      this.$http.getProductList(params).then(res => {
        var data = res.data;
        this.dataList = data.list;
        console.log(data);
      }).catch(error => {
        // Dialog({ message: error.data.message });
      })
    },
    select(item) {
      if (!this.projectData.elements) {
        return
      }
      var template = JSON.parse(this.getTemplate);
      template['contentType'] = 'PRODUCT';
      template['contentId'] = item.productId;
      var jsonStr = JSON.stringify(template).replace('--productName--', item.productName)
      template = JSON.parse(jsonStr);
      var e = this.projectData.elements.find(v => {return v.uuid === this.getActiveElementUUID})
      // 设置展品图片
      const url = item.iconUrl ? item.iconUrl.split(',')[0] : '';

      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      const _this = this
      const xhr = new XMLHttpRequest();
      xhr.open('get', url, true);
      // 设置请求头（这一步得设置不然oss图片还是跨域）
      xhr.setRequestHeader("Cache-Control", "no-cache")
      xhr.responseType = 'blob';
      
      xhr.onload = function () {
        if (this.status === 200) {
          const imageSrc = URL.createObjectURL(this.response);
          e.propsValue.imageSrc = imageSrc
          const proJsonStr = JSON.stringify(_this.projectData).replace('--productName--', item.productName)
          _this.$store.commit('setPrjectData', JSON.parse(proJsonStr))
          _this.$store.commit('setTemplate', JSON.stringify(template))
          _this.$router.go(-1);
        }
      };
      xhr.send();

      // e.propsValue.imageSrc = item.iconUrl ? item.iconUrl.split(',')[0] : '';
      // var proJsonStr = JSON.stringify(this.projectData).replace('--productName--', item.productName)
      // // this.projectData = JSON.parse(proJsonStr)
      // this.$store.commit('setPrjectData', JSON.parse(proJsonStr))
      // this.$store.commit('setTemplate', JSON.stringify(template))
      // this.$router.go(-1);
      // 修复选择完背景图 edit-shape-point还存在的 bug
      // this.$store.dispatch('setActiveElementUUID', '');
    },
    getImage(url) {
      const _this = this
      var xhr = new XMLHttpRequest();
      xhr.open('get', url, true);
      // 设置请求头（这一步得设置不然oss图片还是跨域）
      xhr.setRequestHeader("Cache-Control", "no-cache")
      xhr.responseType = 'blob';
      
      xhr.onload = function () {
        if (this.status === 200) {
          const imageSrc = URL.createObjectURL(this.response);
          console.log('this.response', imageSrc)

          if (_this.activePage) {
            _this.activePage.elements.map(item => {
              if (item.uuid === "b515ea8a-7a34-4b6c-8d47-d5c26ab4dbec") {
                item.propsValue.imageSrc =  imageSrc
              }
              return item
            })
          }
        }
      };
      xhr.send();
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getData();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.goods-view {
  height: 145px;
  background: #FFFFFF;
  padding: 15px;
  display: flex;
}
.goods-icon {
  margin-right: 20px;
  width: 110px;
  height: 110px;
  background: #C9CED6;
  border-radius: 10px;
}
.goods-desc-view {
  flex: 1;
  position: relative;
}
.goods-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
}
.goods-select {
  height: 24.5px;
  line-height: 24.5px;
  background: #4B5173;
  border-radius: 12.5px;
  padding: 0px 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  position: absolute;
  bottom: 18px;
  right: 17px;
}
.nodata-view {
  margin-top: 150px;
}
</style>
